import Container from '../../components/menu/Container';
import { useTranslation } from "react-i18next";
import ServicoList from './ServicoList';
import React, { useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import ServicoCadastrar from './ServicoCadastrar';
import { Messages } from 'primereact/messages';
import postServico from "../../service/postServico";
import putServico from '../../service/putServico';

export default function ServicoPage() {
  const { t } = useTranslation();
  const msgs = useRef<Messages>(null);
  const [servico, setServico] = useState<any | null>(null);
  const labelButton = t('cadastrar')
  const saveServico = (servico:any) => {
    if(servico.id){
      putServico(servico).then(data => {
        if(data.includes('Erro')){
          if (msgs.current) {
            msgs.current?.clear();
            msgs.current?.show([
                { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: data, closable: false }
               
            ]);
          }
        }
        else{
          setServico(null);
          if (msgs.current) {
            msgs.current?.clear();
            msgs.current?.show([
                { sticky: false, life: 10000, severity: 'success', summary: 'Sucesso', detail: data, closable: false }
               
            ]);
          }
        }
      })
    }
    else{
      postServico(servico).then(data => {
        if(data.includes('Erro')){
          if (msgs.current) {
            msgs.current?.clear();
            msgs.current?.show([
                { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: data, closable: false }
               
            ]);
          }
        }
        else{
          setServico(null);
          if (msgs.current) {
            msgs.current?.clear();
            msgs.current?.show([
                { sticky: false, life: 10000, severity: 'success', summary: 'Sucesso', detail: data, closable: false }
               
            ]);
          }
        }
      })
    }
    
    
  }
  const startContent = (
    <React.Fragment>
        <Button label={labelButton} icon="pi pi-plus" style={{backgroundColor:'#183462'}} onClick={() => {setServico({})}}/>
    </React.Fragment>
);

  return (
    <Container>
      <div className="row">
          <div className="col-lg-12 mb-3">
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
              <h1 className="h3 mb-0 text-gray"><i className="pi pi-server" style={{ fontSize: '2.0rem' }}></i> {t('servicos')}</h1>
            </div>     
          </div>
      </div>
      <div className="card">
        <Messages ref={msgs} />
        {!servico && (
          <>
            <Toolbar start={startContent} />
            <br></br>
            <br></br>
            <ServicoList onEdit={(servico:any) => { setServico(servico);}}></ServicoList>
          </>
        )}
        {servico && (
          <>
           <ServicoCadastrar servico={servico} onSave={saveServico} onClose={() => {setServico(null)}}></ServicoCadastrar>
          </>
        )}
      </div>
                
    </Container>
  )
}
